export const adventCalendarSOMEImagePath = "/public-images/adventCalendarSOMEImage.jpg";
